import { useSyncExternalStore } from "react";

type Listener = () => void;

const listeners = new Set<Listener>();
const store = { count: 0 };

function subscribe(l: Listener) {
  listeners.add(l);
  return () => listeners.delete(l);
}

function emit() {
  for (const l of listeners) l();
}

export function beginTyping() {
  store.count++;
  emit();
}

export function endTyping() {
  if (store.count > 0) store.count--;
  emit();
}

export async function wrapTyping<T>(fn: () => Promise<T>): Promise<T> {
  beginTyping();
  try {
    return await fn();
  } finally {
    endTyping();
  }
}

function snapshot() {
  return store.count > 0;
}

/** Read-only hook for components to react to typing changes */
export function useIsTyping() {
  return useSyncExternalStore(subscribe, snapshot, snapshot);
}

/** Synchronous guard for event handlers; returns true if action should be blocked */
export function shouldBlockActions() {
  return snapshot();
}
